function removeNonUTF8(str: string) {
  return str.replace(/[^\x00-\x7F]/g, '');
}

export default function encodeAndStringify(input: any): string {
  return btoa(removeNonUTF8(JSON.stringify(input)));
}
